export default __webpack_public_path__ + "static/media/Ballroll_00367.752a7444.png";